import { render, staticRenderFns } from "./uiImg.vue?vue&type=template&id=ba67a89a"
import script from "./uiImg.vue?vue&type=script&lang=js"
export * from "./uiImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports